module.exports = __webpack_public_path__ + "img/logo-black.dbd8e3d6.svg";